import { IconProps } from '@mui/material';
import { Classes } from '@mui/styles/mergeClasses/mergeClasses';
import React from 'react'

export interface CcfTabPanelProps {
  children?: React.ReactElement,
  label?: string,
  icon?: React.ReactElement,
  classes?: Classes,
  tooltip?: string;
  disabled?: boolean
}

/**
 * 
 * @param param0 - CcfTabPanelProps
 * @example <CcfTabsPanel />
 * @returns 
 */
export function CcfTabsPanel({children}: CcfTabPanelProps) {
  return <>{children}</>;
}

export default CcfTabsPanel;